"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PRODUCT_IMAGE_WRAPPER_HEIGHT = exports.PRODUCT_IMAGE_SIZE = exports.PRODUCT_IMAGE_PLACEHOLDER = exports.PRODUCT_IMAGE = void 0;
const PRODUCT_IMAGE = exports.PRODUCT_IMAGE = 'product-image';
const PRODUCT_IMAGE_PLACEHOLDER = exports.PRODUCT_IMAGE_PLACEHOLDER = 'product-image-placeholder';
const PRODUCT_IMAGE_SIZE = exports.PRODUCT_IMAGE_SIZE = 80;
const PRODUCT_IMAGE_WRAPPER_HEIGHT = exports.PRODUCT_IMAGE_WRAPPER_HEIGHT = 110;
